var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.969 183.031L328.969 7.031C324.281 2.344 318.141 0 312 0S299.719 2.344 295.031 7.031C285.656 16.406 285.656 31.594 295.031 40.969L310.19 56.127L32.936 332.625C-5.814 371.375 -12.189 434.625 23.561 476.125C44.078 500 72.764 512 101.488 512H101.936C128.311 512 154.686 502 174.811 481.875L455.846 201.783L471.031 216.969C475.719 221.656 481.844 224 488 224S500.281 221.656 504.969 216.969C514.344 207.594 514.344 192.406 504.969 183.031ZM333.449 256H177.746L344.084 90.115L344.127 90.072L421.901 167.846L333.449 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVial);
export default __webpack_public_path__ + "static/media/vial.35f6100845f0f38af6747a66fd014dd3.svg";
export { ForwardRef as ReactComponent };